import React from 'react';
import { makeStyles, withStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import MessageIcon from '@material-ui/icons/Message';
import PropTypes from 'prop-types';

const StyledMessageIcon = withStyles(theme => ({
  root: {
    color: theme.palette.primary.main,
  },
}))(MessageIcon);

const useStyles = makeStyles(theme => ({
  root: {
    padding: '0.5rem 0.5rem 0.5rem 0rem',
    display: 'flex',
    flexWrap: 'nowrap',
    alignContent: 'left',
    justifyContent: 'flex-start',
    alignItems: 'center',
  },
  icon: {
    margin: '0 10px',
  },
  text: {
    padding: 0,
    paddingLeft: '0px',
    fontSize: '0.9rem',
    color: theme.palette.primary.main,
  },
}));

const ReviewCount = ({count}) => {
  const classes = useStyles();
  return (
    <div className={classes.root}>
      <StyledMessageIcon className={classes.icon} />
      <Typography variant="caption" color="primary" className={classes.text}>{count} reviews</Typography>
    </div>
  );
};

ReviewCount.propTypes = {
  count: PropTypes.number.isRequired,
};

export default ReviewCount;
